export default __webpack_public_path__ + "static/media/Absolute Farseer Elixir.66d5836b.jpg";